class Megamenu {
  constructor(container) {
    this.selectors = {
      announcementBar: ".m-announcement-bar",
      hamburgerButtons: ".m-hamburger-box",
      desktopMenuItems: [".m-menu__item"],
      desktopSubMenus: ".m-mega-menu",
      headerMobile: ".m-header__mobile",
      menuDrawer: "#m-menu-drawer",
      menuDrawerContent: ".m-menu-drawer__content",
      menu: ".m-menu-mobile",
      menuItems: [".m-menu-mobile__item"],
      megaMenuMobile: [".m-megamenu-mobile"],
      backDrop: ".m-menu-drawer__backdrop",
    };
    this.menuSelectors = {
      subMenu: ".m-mega-menu",
    };
    this.activeDesktopMenuItem = null;

    this.sliders = {};
    this.open = false;
    this.container = container;
    this.transitionDuration = 0;
    this.domNodes = queryDomNodes(this.selectors);
    this.menuData = [...this.domNodes.desktopMenuItems].map((item) => {
      const header = item.closest("header");
      const menuNodes = queryDomNodes(this.menuSelectors, item);
      return { header, item, ...menuNodes, active: false };
    });
    this.init();

    MinimogTheme = MinimogTheme || {};
    MinimogTheme.headerSliders = this.sliders;
  }

  init() {
    this.domNodes.hamburgerButtons.addEventListener("click", (e) => {
      if (this.domNodes.hamburgerButtons.classList.contains("active")) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
      this.domNodes.hamburgerButtons.classList.toggle("active");
    });
    this.domNodes.backDrop.addEventListener("click", (e) => {
      this.closeMenu();
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.open) {
        e.preventDefault();
        this.closeMenu();
        this.domNodes.hamburgerButtons.focus();
      }
    });
    this.initMobileMegaMenu();
    this.initDesktopMegaMenu();

    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openCartDrawer, () => {
      this.open && this.closeMenu();
    });
    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openSearchPopup, () => {
      this.open && this.closeMenu();
    });
  }
  initDesktopMegaMenu() {
    [...this.menuData].forEach((menuItem) => {
      const { item, subMenu } = menuItem;
      if (subMenu) {
        const productsBanner = subMenu.querySelector(".m-mega-product-list");
        if (productsBanner) {
          if (window && window.__sfWindowLoaded) {
            menuItem.productsBannerSlider = this.initProductsBanner(productsBanner);
          } else {
            window.addEventListener("load", () => {
              menuItem.productsBannerSlider = this.initProductsBanner(productsBanner);
            });
          }
        }
      }
    });
  }
  closeDesktopSubmenu = (menuItemIndex) => {
    const menuItem = this.menuData[menuItemIndex];
    const { header } = menuItem;
    header && header.classList.remove("show-menu");
  };
  initProductsBanner(banner) {
    const header = banner.closest("header");
    const menuItem = banner.closest(".m-menu__item");
    const screenClass = (header && `.${header.dataset.screen}`) || "";

    const id = banner.dataset.id;
    const sliderContainer = document.querySelector(`.m-product-list-${id}`);
    const columns = sliderContainer.dataset.column;

    let slider;
    slider = new MinimogLibs.Swiper(`${screenClass} .m-product-list-${id}`, {
      slidesPerView: 1,
      loop: false,
      autoplay: false,
      breakpoints: {
        1200: { slidesPerView: columns },
        992: { slidesPerView: columns >= 2 ? 2 : columns },
      },
    });
    this.sliders[menuItem.dataset.index] = slider;

    if (slider) {
      const prevBtn = document.querySelector(`#m-slider-controls-${id} .m-slider-controls__button-prev`);
      const nextBtn = document.querySelector(`#m-slider-controls-${id} .m-slider-controls__button-next`);
      prevBtn && prevBtn.addEventListener("click", () => slider.slidePrev());
      nextBtn && nextBtn.addEventListener("click", () => slider.slideNext());
    }
  }

  initMobileMegaMenu() {
    [...this.domNodes.menuItems].forEach((item) => {
      const subMenuContainer = item.querySelector(":scope > .m-megamenu-mobile");
      if (!subMenuContainer) return;
      const backBtn = subMenuContainer.querySelector(":scope > .m-megamenu-mobile__wrapper > .m-menu-mobile__back-button");
      item.querySelectorAll(":scope > [data-toggle-submenu]").forEach((trigger) => {
        trigger.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.openSubMenu(subMenuContainer, trigger.dataset.toggleSubmenu);
        });
      });
      if (backBtn) {
        backBtn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.closeSubMenu(subMenuContainer, backBtn.dataset.level);
        });
      }
    });
    document.addEventListener("matchMobile", () => this.setMenuHeight());
    document.addEventListener("unmatchMobile", () => this.setMenuHeight());
  }

  //////////////// MOBILE MENU EVENTS
  openMenu() {
    this.setMenuHeight();
    document.documentElement.classList.add("prevent-scroll");
    this.domNodes.menuDrawer.classList.add("open");
    this.domNodes.menuDrawer.setAttribute("aria-hidden", "false");
    this.domNodes.hamburgerButtons.setAttribute("aria-expanded", "true");
    this.domNodes.hamburgerButtons.setAttribute("aria-label", "Close menu");
    this.domNodes.headerMobile.classList.add("header-drawer-open");
    this.open = true;
  }

  closeMenu() {
    const { menuDrawer, menu, megaMenuMobile, hamburgerButtons } = this.domNodes;

    setTimeout(() => {
      megaMenuMobile.forEach((container) => {
        container.classList.remove("open");
      });
      menuDrawer.querySelectorAll(".cabana-catalog-group__toggle").forEach((trigger) => trigger.setAttribute("aria-expanded", "false"));
      menu && menu.classList.remove("m-submenu-open", "m-submenu-open--level-1", "m-submenu-open--level-2");
      menuDrawer.classList.remove("open");
      menuDrawer.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("prevent-scroll");
      this.domNodes.headerMobile.classList.remove("header-drawer-open");
      hamburgerButtons.classList.remove("active");
      hamburgerButtons.setAttribute("aria-expanded", "false");
      hamburgerButtons.setAttribute("aria-label", "Open menu");
      // Close search
    }, this.transitionDuration);
    this.open = false;
  }

  openSubMenu(subMenuContainer, level) {
    let subMenuOpenClass = `m-submenu-open--level-${level}`;

    this.domNodes.menuDrawerContent.classList.add("open-submenu");
    this.domNodes.menu && this.domNodes.menu.classList.add("m-submenu-open");
    this.domNodes.menu && this.domNodes.menu.classList.add(subMenuOpenClass);
    const parentList = subMenuContainer.parentElement.parentElement;
    parentList.querySelectorAll(":scope > .m-menu-mobile__item > .m-megamenu-mobile.open").forEach((panel) => {
      if (panel === subMenuContainer) return;
      panel.classList.remove("open");
      panel.parentElement.querySelectorAll(":scope > [data-toggle-submenu]").forEach((button) => button.setAttribute("aria-expanded", "false"));
    });
    subMenuContainer.classList.add("open");
    const trigger = subMenuContainer.parentElement.querySelector(":scope > .cabana-catalog-group__toggle");
    if (trigger) {
      trigger.setAttribute("aria-expanded", "true");
      subMenuContainer.querySelector(".m-menu-mobile__back-button")?.focus();
    }
  }

  closeSubMenu(subMenuContainer, level) {
    let subMenuOpenClass = `m-submenu-open--level-${level}`;

    level === "1" && this.domNodes.menu && this.domNodes.menu.classList.remove("m-submenu-open");
    this.domNodes.menu && this.domNodes.menu.classList.remove(subMenuOpenClass);
    subMenuContainer.classList.remove("open");
    this.domNodes.menuDrawerContent.classList.remove("open-submenu");
    const trigger = subMenuContainer.parentElement.querySelector(":scope > .cabana-catalog-group__toggle");
    if (trigger) {
      trigger.setAttribute("aria-expanded", "false");
      trigger.focus();
    }
  }

  setMenuHeight() {
    const { menuDrawer, headerMobile } = this.domNodes;
    const offsetBottom = headerMobile.getBoundingClientRect().bottom;
    const panelHeight = window.innerHeight - offsetBottom;

    menuDrawer.style.setProperty("--menu-drawer-height", `${panelHeight}px`);
  }
}
class SiteNav {
  constructor(container) {
    this.selectors = {
      menuItems: [".m-menu .m-menu__item"],
      dropdowns: [".m-mega-menu"],
      subMenu: ".m-mega-menu",
      overlay: ".m-header__overlay",
      swiper: ".swiper-container",
    };

    this.classes = {
      slideFromRight: "slide-from-right",
      slideReveal: "slide-reveal",
      active: "m-mega-active",
    };

    this.headerSticky = false;

    if (!container) return;
    this.container = container;
    this.domNodes = queryDomNodes(this.selectors, this.container);
    this.activeIndex = -1;
    this.lastActiveIndex = -1;
    this.visited = false;
    this.timeoutEnter = null;
    this.timeoutLeave = null;
    this.attachEvents();
  }

  attachEvents = () => {
    this.domNodes.menuItems.forEach((menuItem, index) => {
      menuItem.addEventListener("mouseenter", (evt) => this.onMenuItemEnter(evt, index));
      menuItem.addEventListener("mouseleave", (evt) => this.onMenuItemLeave(evt, index));

      const mainLink = menuItem.querySelector(":scope > .m-menu__link--main");
      if (mainLink && menuItem.querySelector(this.selectors.subMenu)) {
        mainLink.addEventListener("click", (evt) => this.onMenuItemClick(evt, index));
        mainLink.addEventListener("keydown", (evt) => {
          if (evt.key === "Tab" && !evt.shiftKey && mainLink.getAttribute("aria-expanded") === "true") {
            const firstMenuLink = menuItem.querySelector(".m-mega-menu a[href], .m-mega-menu button:not([disabled])");
            if (firstMenuLink) {
              evt.preventDefault();
              firstMenuLink.style.visibility = "visible";
              firstMenuLink.style.pointerEvents = "auto";
              firstMenuLink.focus();
            }
          }
        });
        menuItem.addEventListener("focusout", () => {
          window.setTimeout(() => {
            if (!menuItem.contains(document.activeElement)) this.closeDesktopMenu(false);
          }, 0);
        });
      }
    });
    document.addEventListener("keydown", this.onDocumentKeydown);
    document.addEventListener("click", this.onDocumentClick);
  };

  onDocumentKeydown = (evt) => {
    if (evt.key === "Escape" && this.container.querySelector(".m-menu__item--active")) {
      evt.preventDefault();
      this.closeDesktopMenu(true);
    }
  };

  onDocumentClick = (evt) => {
    if (!this.container.contains(evt.target)) this.closeDesktopMenu(false);
  };

  closeDesktopMenu = (returnFocus) => {
    const activeItem = this.container.querySelector(".m-menu__item--active");
    const trigger = activeItem && activeItem.querySelector(":scope > .m-menu__link--main");
    this.resetMegaMenu();
    if (returnFocus && trigger) trigger.focus();
  };

  onMenuItemClick = (evt, index) => {
    if (window.innerWidth < 1024) return;

    const menuItem = this.domNodes.menuItems[index];
    if (!menuItem) return;

    evt.preventDefault();
    if (menuItem.classList.contains("m-menu__item--active")) {
      this.closeDesktopMenu(true);
      return;
    }
    this.onMenuItemEnter({ target: menuItem }, index);
    this.container.classList.add(this.classes.active);
    menuItem.classList.add("m-menu__item--active");
    const trigger = menuItem.querySelector(":scope > .m-menu__link--main");
    trigger && trigger.setAttribute("aria-expanded", "true");
  };

  initDropdownSize = () => {
    this.container && this.container.style.setProperty("--sf-dropdown-width", this.windowWidth());
    this.container && this.container.style.setProperty("--sf-dropdown-height", this.windowHeight());
  };

  onMenuItemEnter = (evt, index) => {
    const { target } = evt;

    if (!target.classList.contains("m-menu__item--mega")) return;

    clearTimeout(this.timeoutLeave);
    this.activeIndex = target.dataset && Number(target.dataset.index);
    this.headerSticky = this.container && this.container.dataset.sticky === "true";
    this.reInitSlider(target);

    this.container && this.visited
      ? this.container.classList.remove(this.classes.slideReveal)
      : this.container.classList.add(this.classes.slideReveal);

    this.visited = true;
    this.lastActiveIndex >= 0 &&
      this.activeIndex >= 0 &&
      (this.container && this.lastActiveIndex < this.activeIndex
        ? this.container.classList.add(this.classes.slideFromRight)
        : this.lastActiveIndex > this.activeIndex && this.container.classList.remove(this.classes.slideFromRight));

    this.getElementBoundingRect(target).then((rect) => {
      if (rect) {
        this.container && this.container.style.setProperty("--sf-dropdown-width", rect.width);
        this.container && this.container.style.setProperty("--sf-dropdown-height", rect.height);
      }

      this.timeoutEnter = setTimeout(() => {
        if (this.activeIndex !== Number(target.dataset.index)) return;
        this.container && this.container.classList.add(this.classes.active);
        target.closest(".m-menu__item").classList.add("m-menu__item--active");
        const trigger = target.querySelector(":scope > .m-menu__link--main");
        trigger && trigger.setAttribute("aria-expanded", "true");
        // document.documentElement.classList.add("prevent-scroll");
      }, 120);
    });
  };

  onMenuItemLeave = (evt, index) => {
    if (evt.target.contains(document.activeElement)) return;
    this.activeIndex = -1;
    this.lastActiveIndex = index;
    evt.target.closest(".m-menu__item").classList.remove("m-menu__item--active");
    const trigger = evt.target.querySelector(":scope > .m-menu__link--main");
    trigger && trigger.setAttribute("aria-expanded", "false");
    // document.documentElement.classList.remove("prevent-scroll");

    this.timeoutLeave = setTimeout(() => {
      if (this.activeIndex === -1 || this.activeIndex < 0) {
        this.visited = false;
      }
      this.resetMegaMenu(evt.target);
    }, 80);
  };

  reInitSlider = (menuItem) => {
    const swiper = menuItem.querySelector(this.selectors.swiper);
    if (!swiper) return;
    const itemIndex = menuItem.dataset.index;
    const slider = MinimogTheme && MinimogTheme.headerSliders[itemIndex];
    slider && slider.update();
  };

  getElementBoundingRect = async (element) => {
    const subMenu = element.querySelector(this.selectors.subMenu);
    if (subMenu) {
      const rect = subMenu.getBoundingClientRect();
      return {
        width: rect.width,
        height: rect.height,
        left: rect.left,
        top: rect.top,
      };
    }
  };

  resetMegaMenu = () => {
    this.activeIndex = -1;

    clearTimeout(this.timeoutEnter);
    this.domNodes.menuItems.forEach((item) => {
      item.classList.remove("m-menu__item--active");
      const trigger = item.querySelector(":scope > .m-menu__link--main");
      trigger && trigger.setAttribute("aria-expanded", "false");
      const firstMenuLink = item.querySelector(".m-mega-menu a[href], .m-mega-menu button:not([disabled])");
      firstMenuLink?.style.removeProperty("visibility");
      firstMenuLink?.style.removeProperty("pointer-events");
    });
    this.container &&
      this.container.classList.remove(
        this.classes.active,
        this.classes.slideFromRight,
        this.classes.slideReveal,
        "sf-header--bg-black",
        "sf-header--bg-white"
      );
  };

  windowWidth = () => {
    return window.innerWidth;
  };
  windowHeight = () => {
    return window.innerHeight;
  };

  destroy = () => {
    this.domNodes.menuItems.forEach((menuItem, index) => {
      menuItem.removeEventListener("mouseenter", (evt) => this.onMenuItemEnter(evt, index));
      menuItem.removeEventListener("mouseleave", (evt) => this.onMenuItemLeave(evt, index));
    });
  };
}
